import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { IRegEdConnectionTestResult } from './types';

/**
 * A failed probe still resolves as an HTTP success — read the outcome from the body's
 * `success`/`message`, not the error path.
 */
export const useRegEdConnectionTestMutation = ({
	onError,
	onSuccess,
}: {
	onError?: (error: Api.IOperationResultNoValue) => void;
	onSuccess?: (result: IRegEdConnectionTestResult) => void;
} = {}) => {
	const userSession = useUserSession();
	return useMutation({
		mutationFn: ({
			brokerDealerId,
			impersonationContext,
		}: {
			brokerDealerId: string;
			impersonationContext?: Api.IImpersonationContext;
		}) =>
			userSession.webServiceHelper.callAsync<IRegEdConnectionTestResult>(
				Api.ImpersonationBroker.composeApiUrl({
					impersonationContext,
					urlPath: `compliance/regEd/brokerDealers/${encodeURIComponent(brokerDealerId)}/connectionTest`,
				}),
				'POST',
				null
			),
		onError,
		onSuccess,
	});
};
